import styled from 'styled-components';
import { ButtonLarge } from '../../../../components/Css';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  width: 100%;
  margin-top: var(--spacing-large);
`;

export const StyledButton = styled(ButtonLarge)`
  display: flex;
  align-items: center;
  justify-content: left;
  gap: var(--spacing-small);
  text-align: left;
  border-color: var(--color-neutral-light-lighter) !important;
  border-width: 1px !important;
  box-shadow: 1px 1px 5px 1px var(--color-neutral-light) !important;
  color: var(--color-text) !important;
  
  & > .anticon {
    color: var(--color-highlight) !important;
  }
  
  &:hover {
    color: #fff !important;
    
    & > .anticon {
      color: #fff !important;
    }
  }
`;

